import {WlMultiLayer, WlLayer} from "./layers.component";
import {defineWebComponent} from "../webcomponents-utils";

export * from './layers.component';
export default WlMultiLayer;

defineWebComponent('wl-multilayer', WlMultiLayer);
defineWebComponent('wl-layer', WlLayer);